export const TAG_LOCALE = {
    addText: 'Add',
    placeholder: 'Please input'
};